"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var helpers_1 = require("../../utils/helpers");
var styles_1 = require("./styles");
function Chip(_a) {
    var children = _a.children, style = _a.style, className = _a.className, _b = _a.type, type = _b === void 0 ? "primary" : _b;
    var mainStyles = (0, helpers_1.getStyledComponentMainStyles)(type);
    return (react_1.default.createElement(styles_1.MainContainer, { style: __assign(__assign({}, mainStyles), style), className: className }, children));
}
exports.default = Chip;
//# sourceMappingURL=index.js.map